export default {"src":"/_next/static/media/download-icon-orange.654a1c8a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};